import $ from 'jquery';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

const bodyHtml = $('body,html');
const body = $('body');

/* ======================================
body fix
====================================== */
let scrollPosi;
let isScrolling = false

const dataText = {
	'item1': {
		'text1': 'S.Y.',
		'text2': 'FP事業部 生産部 FV生産課<br>2023年3月／中途',
	},
	'item2': {
		'text1': 'S.F.',
		'text2': '開発推進本部 本部長<br>2003年4月／新卒',
	},
	'item3': {
		'text1': 'K.K.',
		'text2': '開発推進本部 開発部<br>2021年入社／新卒',
	},
}

function bodyFix() {
	scrollPosi = $(window).scrollTop();

	body.addClass('is-fixed');
	body.css({ top: -scrollPosi });
}

function bodyFixReset() {
	body.removeClass('is-fixed');
	body.removeAttr('style');
	bodyHtml.scrollTop(scrollPosi);
}

$(function () {
	const modal = $('.js-modal')
	const btnModal = $('.js-modal-open')
	const btnModalClose = $('.js-modal-close')
	const modalSlide = $('.js-modal-slide')
	const nextBtn = $('.js-modal-next')
	const prevBtn = $('.js-modal-prev')
	const nextText1 = $('.js-modal-next-text1')
	const nextText2 = $('.js-modal-next-text2')
	const prevText1 = $('.js-modal-prev-text1')
	const prevText2 = $('.js-modal-prev-text2')
	let slideModal
	let dataIndex = 0

	const options = {
		loop: true,
		autoHeight: true,
		observer: true,
		effect: "fade",
		noSwiping: false,
		allowTouchMove: false,
	}

	function handleTextControl(dataIndex) {
		if (dataIndex === 0) {
			prevText1.html(dataText.item1.text1)
			prevText2.html(dataText.item1.text2)
			nextText1.html(dataText.item2.text1)
			nextText2.html(dataText.item2.text2)
		}

		if (dataIndex === 1) {
			prevText1.html(dataText.item3.text1)
			prevText2.html(dataText.item3.text2)
			nextText1.html(dataText.item1.text1)
			nextText2.html(dataText.item1.text2)
		}

		if (dataIndex === 2) {
			prevText1.html(dataText.item2.text1)
			prevText2.html(dataText.item2.text2)
			nextText1.html(dataText.item3.text1)
			nextText2.html(dataText.item3.text2)
		}
	}

	if (modalSlide.length) {
		slideModal && slideModal.destroy()
		slideModal = new Swiper(modalSlide[0], options);

		nextBtn.on('click', function () {
			slideModal.slideNext()
		})

		prevBtn.on('click', function () {
			slideModal.slidePrev()
		})
	}

	if (btnModal.length) {

		btnModal.on('click', function () {
			dataIndex = 0
			slideModal && slideModal.destroy()
			slideModal = new Swiper(modalSlide[0], options);

			if ($('.js-header').hasClass('is-scrolling') || $(window).scrollTop() > 50) {
				isScrolling = true
			}

			bodyFix()
			dataIndex = Number($(this).attr('data-modal-index'))
			slideModal.slideTo(dataIndex)

			if (!modal.hasClass('is-active')) {
				modal.addClass('is-active')
			}

			handleTextControl(dataIndex)

			setTimeout(() => {
				if (isScrolling) {
					$('.js-header').addClass('is-scrolling')
				}
			}, 20);

			slideModal.on('activeIndexChange', function () {
				handleTextControl(slideModal.realIndex)
			})
		})

		function handleCloseModal() {
			bodyFixReset()
			modal.removeClass('is-active')

			setTimeout(() => {
				slideModal && slideModal.destroy()
			}, 0);

			setTimeout(() => {
				if (isScrolling) {
					$('.js-header').addClass('is-scrolling')
				}
			}, 0);
		}

		btnModalClose.on('click', function () {
			handleCloseModal()
		})

		$(window).on('click', function (e) {
			if ($(e.target).is('.js-modal-scroll')) {
				handleCloseModal()
			}
		})

		$(window).on('load resize', function () {
			if ($(window).outerWidth() < 961) {
				modal.css('height', $(window).innerHeight())

			} else {
				modal.removeAttr('style')
			}
		})

		$(window).on('load scroll', function () {
			if ($('.js-header').hasClass('is-scrolling')) {
				$('.js-header').addClass('is-scrolling')
			}
		})
	}
})
